module.exports = __webpack_public_path__ + "img/ic_credit-card_payment-method-light.942f634.svg";